import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onConvertToOnline", "onLinkToVideoCall"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { IconButton, Menu, MenuButton, MenuItem, MenuList, Portal, useDisclosure } from '@chakra-ui/react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '../common/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var VideoActionButton = function VideoActionButton(_ref) {
  var _ref$onConvertToOnlin = _ref.onConvertToOnline,
      onConvertToOnline = _ref$onConvertToOnlin === void 0 ? function () {} : _ref$onConvertToOnlin,
      _ref$onLinkToVideoCal = _ref.onLinkToVideoCall,
      onLinkToVideoCall = _ref$onLinkToVideoCal === void 0 ? function () {} : _ref$onLinkToVideoCal,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useDisclosure = useDisclosure(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var _useState = useState(0),
      menuIndex = _useState[0],
      setMenuIndex = _useState[1];

  var _useTranslation = useTranslation(['common', 'booking']),
      t = _useTranslation.t;

  var _useDisclosure2 = useDisclosure(),
      isMenuOpen = _useDisclosure2.isOpen,
      onMenuOpen = _useDisclosure2.onOpen,
      onMenuClose = _useDisclosure2.onClose;

  var menuSettings = useMemo(function () {
    return [{
      modal: {
        confirmButtonText: t('common:status.readyForVideo', '準備好了，進入視訊'),
        cancelButtonText: t('common:button.cancel', '取消'),
        title: t('common:attention', '注意'),
        message: t('common:useCofitAccount', '視訊時，請務必選用「COFIT 營養師」這個 Google 帳號進行視訊面談')
      },
      onApply: onLinkToVideoCall
    }, {
      modal: {
        confirmButtonText: "".concat(t('common:button.confirm', '確認'), "\uFF08").concat(t('common:waitForLinkUpdate', '請等候30秒更新連結'), "\uFF09"),
        title: t('common:status.switchOnline', '轉線上'),
        message: t('common:status.switchOnlineDetails', '1. 客戶將收到該筆預約的LINE通知，且地點改為「線上視訊」。\n2. 後續相關LINE通知也將改為「線上視訊」。')
      },
      onApply: onConvertToOnline
    }];
  }, [t, onLinkToVideoCall, onConvertToOnline]);

  var handleClick = function handleClick(idx) {
    return function () {
      setMenuIndex(idx);
      onOpen();
    };
  };

  var menuSetting = useMemo(function () {
    return menuSettings[menuIndex];
  }, [menuSettings, menuIndex]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Menu, {
      isOpen: isMenuOpen,
      offset: [-1, -1],
      e2eid: "Booking_VideoActionButton_Menu",
      children: [/*#__PURE__*/_jsx(MenuButton, _objectSpread(_objectSpread({
        as: IconButton,
        "aria-label": "task",
        colorScheme: "brandScheme"
      }, rest), {}, {
        onMouseEnter: onMenuOpen,
        onMouseLeave: onMenuClose,
        e2eid: "Booking_VideoActionButton_MenuButton"
      })), /*#__PURE__*/_jsx(Portal, {
        e2eid: "Booking_VideoActionButton_Portal",
        children: /*#__PURE__*/_jsxs(MenuList, {
          onMouseEnter: onMenuOpen,
          onMouseLeave: onMenuClose,
          e2eid: "Booking_VideoActionButton_MenuList",
          children: [/*#__PURE__*/_jsx(MenuItem, {
            onClick: handleClick(0),
            e2eid: "Booking_VideoActionButton_MenuItem",
            children: t('common:status.intoVideoCallLink', '進入視訊連結')
          }), /*#__PURE__*/_jsx(MenuItem, {
            onClick: handleClick(1),
            e2eid: "Booking_VideoActionButton_MenuItem_5",
            children: t('common:status.switchOnline', '轉線上')
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(ConfirmModal, _objectSpread(_objectSpread({
      isOpen: isOpen
    }, menuSetting === null || menuSetting === void 0 ? void 0 : menuSetting.modal), {}, {
      onClose: onClose,
      onApply: menuSetting === null || menuSetting === void 0 ? void 0 : menuSetting.onApply,
      e2eid: "Booking_VideoActionButton_ConfirmModal"
    }))]
  });
};